var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"fm-audio-player-modal","title":_vm.lang.modal.audioPlayer.title,"visible":"","centered":"","hide-footer":""},on:{"hidden":_vm.hideModal}},[_c('vue-plyr',{attrs:{"options":_vm.playerOptions}},[_c('audio',{ref:"fmAudio",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.audioSource}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }